import TagManager from 'react-gtm-module';
import config from 'src/utils/env';

const gtmId = config.googleTagManagerId;
if (gtmId) {
  TagManager.initialize({
    gtmId,
  });
}
